const goOutMyRecordData = []
const cancelRecordList = []
const couponDetailById = {}
export default {
  couponDetailById,
  cancelRecordList,
  goOutMyRecordData
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/my-record/store/state.js